import React, { useEffect, useState, useRef } from 'react'
import { compilationScrollbarSettings } from '../../../../constants/copyright'
import classNames from 'classnames'
import RatingItem from '../../../pages/rating/rating-item/RatingItem'
import Scrollbar from 'react-scrollbars-custom'
import { useUser } from '../../../../redux/reducer/user'
import { useApplicationCallbacks } from '../../../../providers/application-callbacks'
import { RATING_LIST_RANGE } from '../../../../constants/shared/rating/list'

const RatingItems = React.forwardRef(function (
  { ratingInfo, ratingCount = RATING_LIST_RANGE, mod, isPending = false },
  ref,
) {
  const {
    profile: { iconId },
  } = useUser()
  const [isActiveVisible, setIsActiveVisible] = useState(false)
  const activeItemRef = useRef(null)
  const callbacks = useApplicationCallbacks()

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (entry) =>
            entry.target === activeItemRef.current && setIsActiveVisible(entry.isIntersecting),
        ),
      { root: null, rootMargin: '0px', threshold: 0.1 },
    )

    activeItemRef.current && observer.observe(activeItemRef.current)

    return () => observer.disconnect()
  }, [ratingInfo])

  const ratings = ratingInfo?.activeRatings?.rating ?? []
  const activeList = Array.isArray(ratings) ? ratings.slice(0, ratingCount ?? Number.MAX_VALUE) : []

  const isShowUserInfo =
    !!ratingInfo?.activeRatings?.user && !!Object.values(ratingInfo?.activeRatings?.user).length

  return (
    <div
      ref={ref}
      className={classNames('rating__items', 'rating__items_noNy', {
        ['rating__items_out']: ratingInfo?.isInsideRating,
        [`rating__items_${mod}`]: mod,
      })}
    >
      <div className={'rating__items-block'}>
        <Scrollbar {...compilationScrollbarSettings}>
          {activeList?.map((item, index) => {
            const isActive = ratingInfo?.activeRatings?.user?.uid === item?.uid
            return (
              <RatingItem
                key={`item-${index}`}
                index={index}
                active={isActive}
                callbacks={callbacks}
                {...item}
                {...(isActive && { ref: activeItemRef })}
                isActiveVisible={isActiveVisible}
                isShowUserInfo={isShowUserInfo}
                isPending={isPending}
              />
            )
          })}
        </Scrollbar>
      </div>

      {isShowUserInfo && (
        <RatingItem
          iconId={iconId}
          visible={!isActiveVisible}
          isOutOfRating={true}
          callbacks={callbacks}
          {...ratingInfo?.activeRatings?.user}
          isPending={isPending}
        />
      )}
    </div>
  )
})

export default RatingItems
RatingItems.propTypes = {}
